import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Button.scss';

class Button extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    type: PropTypes.string,
    transparent: PropTypes.bool,
    outline: PropTypes.bool,
    block: PropTypes.bool,
    size: PropTypes.string,
    clamp: PropTypes.bool,
    round: PropTypes.bool
  };

  static defaultProps = {
    size: 'normal',
    type: 'primary'
  };

  render() {
    const {
      children,
      className,
      transparent,
      outline,
      type,
      block,
      size,
      clamp,
      round,
      ...props
    } = this.props;
    const classComponent = classNames('button', className, {
      button__sm: size === 'small',
      button__md: size === 'medium',
      button__lg: size === 'large',
      [`button__${type}`]: type,
      button__clamp: clamp,
      button__block: block,
      button__transparent: transparent,
      button__outline: outline,
      button__round: round
    });

    return (
      <button className={classComponent} type={type} {...props}>
        {children}
      </button>
    );
  }
}

export default Button;
